export default __webpack_public_path__ + "static/media/trane.98f87e63.webp";